module.exports = __webpack_public_path__ + "static/media/breadcrumb01.9588d1ab.png";